/**
 * 
 * 自定义Icon图标
 * 
 */

import Icon from '@ant-design/icons';

//  日志
const LogSVG = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" width="1em" height="1em" fill="currentColor">
        <rect x="128" y="128" width="768" height="768" rx="128" fill="none" stroke="currentColor" strokeWidth="64" />
        <path d="M256 320h512M256 512h512M256 704h512" stroke="currentColor" strokeWidth="64" strokeLinecap="round" />
    </svg>
);
export const LogIcon = (props) => <Icon component={LogSVG} {...props} />;

//  日志
const PointLocationSVG = () => (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" >
        <path
            d="M512 192a320 320 0 1 1 0 640 320 320 0 0 1 0-640zm0 64a256 256 0 1 0 0 512 256 256 0 0 0 0-512zm0 128a128 128 0 1 1 0 256 128 128 0 0 1 0-256zm0 64a64 64 0 1 0 0 128 64 64 0 0 0 0-128z"
            fill="none"
            stroke="currentColor"
            stroke-width="64"
        />
    </svg>
);
export const PointLocationIcon = (props) => <Icon component={PointLocationSVG} {...props} />;